import React from 'react';
//import ScrollButton from "../containers/ScrollButton/ScrollButton";
import './Content.scss';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Content from './content/Content';
import ArrowBackStandar from '../ArrowBack/ArrowBackStandar';
import { width } from 'styled-system';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import useScript from '../../utils/customHooks/useScript';
import AntSwitch from '../../utils/props/AntSwitch';
import Grid from '@material-ui/core/Grid';
import MembershipCard from '../MembershipsCards/MembershipCard';
import * as ROUTES from '../../routes';
import MembershipModal from '../Modal/MembershipModal';
import ScrollToTop from '../../components/ScrollToTop';
import { openModalPayments } from '../../store/actions/ModalsActions';
import { connect } from 'react-redux';


function Memberships(props) {
  const breakpoint = useMediaQuery('(min-width:768px)');
  const [state, setState] = React.useState({
    yearlyFirm: false,
  });

  const { platinum, openModalPayments } = props;
  let monthly = 'monthly'; //monthly singlePayments
  let membershipPeriod = state.yearlyLawyer ? 'twelveMonths' : 'sixMonths'; //sixMonths annual

  const handleOpenModal = (membership) => {
    // if (!props.role) {
    //   openModalPayments(true, 'noSession');
    // } else if (props.role === 'lawyer') {
    //   openModalPayments(
    //     true,
    //     'lawFirm',
    //     membership,
    //     membershipPeriod
    //   );
    // } else if (props.role === 'lawFirm') {
    //   openModalPayments(
    //     true,
    //     'lawFirm',
    //     membership,
    //     membershipPeriod
    //   );
    // }
    console.log('soy despacho membresia');
    openModalPayments(
      true,
      'lawFirm',
      'monthly',
      '1,999'
    );
  };

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  return (
    <>
      <ScrollToTop />
      <MembershipModal />
      <div className="mships-container_smallcards">
        <MembershipCard
          type="lawFirm"
          disabledLines
          textBtn='Obtener'
          handleClick={() => {
            handleOpenModal('Premium');
          }}
          title='DESPACHO'
          cost={state.yearlyFirm ? '19,191' : '1,999'}
          oldCost={state.yearlyFirm ? '23,988' : ''}
          moreInfoLink={ROUTES.MEMBERSHIPS_LAWYERS}
          period={state.yearlyFirm}
          // resume={
          //   <span>
          //     <b>Buen posicionamiento</b> en listados de búsqueda, por
          //     detrás de Premium Plus
          //   </span>
          // }              
        />
      </div>
    </>
  );
}

const mapDispatchToProps = (dispatch) => ({
  openModalPayments: (
    open,
    membershipRole,
    typeMembership,
    typePayment,
    membershipPeriod
  ) =>
    dispatch(
      openModalPayments(
        open,
        membershipRole,
        typeMembership,
        typePayment,
        membershipPeriod
      )
    ),
});
const mapStateToProps = (state) => ({
  role: state.authClient.role,
  modalPayments: state.ModalReducer.openModalPayments,
});

export default connect(mapStateToProps, mapDispatchToProps)(Memberships);
